import axios from "axios";

export const getAgedTableHOME= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/aged/selectNormalAgedTable",
        data:params
    })
}

export function getPlatfromNameHOME(){
    return axios({
        method:'GET',
        url:'/system-ya/user/platfrom',
    })
}

export function getDataQtyHOME(){
    return axios({
        method:'POST',
        url:'/system-ya/nbiot/event/getDataQty2',
    })
}

export function getDataQtyHOMEOld(){
    return axios({
        method:'POST',
        url:'/system-ya/nbiot/event/getDataQtyOld',
    })
}

export function loadEventsHOME(){
    return axios({
        method:'POST',
        url:'/system-ya/seat/event/latelyNBiotEventsNew',
    })
}

export const getNBiotEventAgedTableHOME= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/alarmType/tableAged",
        data:params
    })
}

export const detailsWoDialogHOME= (params) =>{
    return axios({
        method:'POST',
        url:'/system-ya/constructionProgramme/infonew/'+params
    })
}

export const handleNBiotEditHOME= (params) =>{
    return axios({
        method:'GET',
        url:'/system-ya/alarmType/infoEvent/'+params
    })
}

export const handleUpdHOME= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/alarmType/updEvent",
        data:params
    })
}

export const getNBiotEventTableHOME= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/alarmType/tableEventNew",
        data:params
    })
}

export function loadTestCall(){
    return axios({
        method:'POST',
        url:'/system-ya/yunCall/testCall',
    })
}

export function getLoginDetails(){
    return axios({
        method:'POST',
        url:'/system-ya/yunCall/getLoginDetails',
    })
}

export function seatsAccess(){
    return axios({
        method:'POST',
        url:'/system-ya/yunCall/seatsAccess',
    })
}

export function goLive(){
    return axios({
        method:'POST',
        url:'/system-ya/yunCall/goLive',
    })
}

export function confirmAdd(){
    return axios({
        method:'POST',
        url:'/system-ya/yunCall/confirm',
    })
}